<template>
    <information-popup modal-id="brickPackagesPopup">
        <template slot="header">
            <!-- no header text required here -->
        </template>
        <slot>
            <div class="modal-body">
                <div class="text-center"><!-- outlined -->
                    <h2>Brick Package</h2>
                    <p>A package purchase includes a customized installed paver, as well as a keepsake certificate delivered to your home or office.</p>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'brick-packages',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .outlined {
        margin-bottom: 40px;
        &:after {
            content: '';
            position: absolute;
            width: 40%;
            left: 30%;
            border-bottom: 1px solid #666;
        }
    }
</style>


// WEBPACK FOOTER //
// BrickPackages.vue?485ec266